import {Component, computed, effect, inject, Signal} from '@angular/core';
import {RouterModule} from '@angular/router';

import {AppConfigFacade} from '@selpia/app-config/data-access';
import {
  LoaderComponent,
  NavButton,
  RightScrollbarWidthDirective,
  SvgSpriteComponent,
  SvgSpriteIcon,
} from '@selpia/shared/ui';
import {MeasuresFacade} from '@selpia/measures/data-access';
import {DimensionItemsFacade} from '@selpia/dimension-items/data-access';
import {FeatureNavComponent} from '@selpia/app-config/feature-nav';
import {FeatureConsentComponent} from '@selpia/user/feature-consent';

import {PagePath} from './page-path.model';
import {MonitoringService} from '@selpia/user/tracking';

@Component({
  imports: [
    RouterModule,
    LoaderComponent,
    SvgSpriteComponent,
    FeatureNavComponent,
    FeatureConsentComponent
  ],
  selector: 'web-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  hostDirectives: [
    RightScrollbarWidthDirective,
  ],
})
export class AppComponent {
  readonly #appConfigFacade = inject(AppConfigFacade);
  readonly #measuresFacade = inject(MeasuresFacade);
  readonly #dimensionItemsFacade = inject(DimensionItemsFacade);
  readonly #monitoringService = inject(MonitoringService);

  protected readonly SvgSpriteIcon = SvgSpriteIcon;

  constructor() {
    this.#measuresFacade.load();

    this.#loadAppConfig();

    this.#monitoringService.logTrace('App Component Initialized');
    this.#monitoringService.logPageView('App Component');
  }

  protected readonly isLoading: Signal<boolean> = computed(() => (this.#appConfigFacade.isLoading() || this.#measuresFacade.isLoading() || this.#dimensionItemsFacade.isLoading()));
  protected readonly isDataReady: Signal<boolean> = computed(() => !this.isLoading() && !!this.#appConfigFacade.initialFocusDimensionLevel());

  protected readonly extraNavButtons: NavButton[] = [
    {
      icon: SvgSpriteIcon.Function,
      label: "Tile View",
      target: `/${PagePath.HotSpotsView}`,
    },
    {
      icon: SvgSpriteIcon.LineChart,
      label: "Detailed Report",
      target: `/${PagePath.ReportView}`,
    },
  ];

  #loadAppConfig(): void {
    const e1 = effect(() => {
        const allMeasures = this.#measuresFacade.measures();

        if (allMeasures) {
          this.#appConfigFacade.load(allMeasures);
          e1.destroy();
        }
      },
      {manualCleanup: true});
  }
}
